import type {
  ICommissionItemAttributeBaseSchema,
} from '@modules/affiliate-program-commissions/submodules/edit/types';
import type { FormSchema } from '@modules/forms/components/VForm/types';

export default function filterOutAttributeSchema<T extends ICommissionItemAttributeBaseSchema>(
  schema: FormSchema<T>,
  index: number,
  attributes: ICommissionItemAttributeBaseSchema[],
): FormSchema<T> {
  const formSchema = {
    ...schema,
  };

  if (attributes.length && attributes[index]?.condition_for_comparison === 'any') {
    delete formSchema.desired_value;
  }

  return formSchema;
}
